export const overview = {
  "composite_score": {
    "value": 70.0,
    "label": "Good",
    "color": "#ff9800",
    "brand": "Warwick Business School (YOU)"
  },
  "competitor_analysis": {
    "title": "Warwick Business School (YOU) vs Competitors Analysis",
    "subtitle": "Warwick Business School (YOU) vs Competitors",
    "x_axis": [
      "Teaching Quality",
      "Academic Reputation",
      "Placement rate",
      "International Outlook",
      "Resources & Infrastructure",
      "Industry & Knowledge Transfer"
    ],
    "y_axis": "Score",
    "chart_type": "combo",
    "series": [
      {
        "name": "Warwick Business School",
        "type": "line",
        "data": [
          85,
          90,
          88,
          75,
          82,
          78
        ]
      },
      {
        "name": "University of Oxford",
        "type": "line",
        "data": [
          92,
          95,
          91,
          85,
          90,
          88
        ]
      },
      {
        "name": "London Business School",
        "type": "line",
        "data": [
          95,
          98,
          95,
          90,
          88,
          92
        ]
      }
    ]
  },
  "performance_table": [
    {
      "university": "Warwick Business School",
      "is_your_brand": false,
      "teaching_quality": 85,
      "academic_reputation": 90,
      "placement_rate": 88,
      "international_outlook": 75,
      "resources_infrastructure": 82,
      "industry_knowledge_transfer": 78,
      "fees": "£43,950",
      "rankings": "Top 100"
    },
    {
      "university": "University of Oxford",
      "is_your_brand": false,
      "teaching_quality": 92,
      "academic_reputation": 95,
      "placement_rate": 91,
      "international_outlook": 85,
      "resources_infrastructure": 90,
      "industry_knowledge_transfer": 88,
      "fees": "£78,540",
      "rankings": "Top 100"
    },
    {
      "university": "London Business School",
      "is_your_brand": false,
      "teaching_quality": 95,
      "academic_reputation": 98,
      "placement_rate": 95,
      "international_outlook": 90,
      "resources_infrastructure": 88,
      "industry_knowledge_transfer": 92,
      "fees": "£109,700",
      "rankings": "Top 100"
    }
  ],
  "references": {
    "methodology": "<div class=\"methodology-content\" style=\"line-height: 1.6; font-family: Arial, sans-serif;\">Title: Evaluation Metrics for MBA Competitor Scores<br><br><strong>Abstract:</strong> This report elucidates the comprehensive framework employed in calculating MBA competitor scores, integrating both qualitative and quantitative metrics. The evaluation encompasses teaching quality, research output, infrastructure, AI visibility, sentiment analysis, rankings, and tuition fee considerations.<br><br><strong>Introduction:</strong> The competitive landscape of MBA programs necessitates a robust evaluative mechanism to discern program excellence. This report delineates the multifaceted criteria employed in assessing MBA competitor scores, serving as a benchmark for prospective students and academic institutions.<br><br><strong>Teaching Quality:</strong> Central to the evaluation is teaching quality, assessed through faculty credentials, student-to-teacher ratios, and pedagogical innovations. Metrics include faculty qualifications, student evaluations, and curriculum relevance, ensuring an optimal learning environment.<br><br><strong>Research Output:</strong> Research, a critical academic pillar, is assessed via publications in reputable journals, citations, and research funding. This metric underscores the program's contribution to academic knowledge and its influence on business practices.<br><br><strong>Infrastructure:</strong> The physical and technological infrastructure is evaluated through campus facilities, technological resources, and learning environments. State-of-the-art infrastructure supports effective learning and research, enhancing overall program appeal.<br><br><strong>AI Visibility:</strong> In an era of technological advancement, AI visibility is crucial. This is measured by the integration of AI in coursework, research initiatives, and collaboration with tech industries, reflecting the program's alignment with contemporary business trends.<br><br><strong>Sentiment Analysis:</strong> Sentiment analysis offers insights into stakeholder perceptions. Data from social media, reviews, and surveys provide a qualitative measure of program reputation, capturing the sentiments of students, alumni, and employers.<br><br><strong>Rankings:</strong> Rankings from reputable bodies are integrated, offering an external validation of program quality. These rankings consider global reputation, employer recognition, and academic excellence.<br><br><strong>Fee Considerations:</strong> Tuition fees are analyzed in relation to program offerings and outcomes. A cost-benefit analysis ensures that the program offers value for money, balancing affordability with educational quality.<br><br><strong>Conclusion:</strong> The comprehensive evaluation framework ensures an objective and holistic assessment of MBA programs. It aids stakeholders in making informed decisions, fostering a competitive academic environment.</div>",
    "sources": [
      {
        "source": "QS World University Rankings",
        "url": "https://www.topuniversities.com/university-rankings/business-masters-rankings/mba/2025",
        "title": "Top MBA Programs in UK 2025 - QS World University Rankings",
        "snippet": "QS World University Rankings for MBA programs in the UK 2025, featuring top institutions like Oxford, Cambridge, and London Business School with comprehensive program details.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Financial Times",
        "url": "https://rankings.ft.com/businessschoolrankings/global-mba-ranking-2025",
        "title": "Financial Times MBA Rankings 2025 - UK Business Schools",
        "snippet": "Financial Times annual MBA rankings 2025 including UK business schools with employment rates, salary data, and career outcomes for graduates.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Complete University Guide",
        "url": "https://www.thecompleteuniversityguide.co.uk/league-tables/rankings",
        "title": "Complete University Guide - MBA Rankings UK",
        "snippet": "Comprehensive university rankings and guides for MBA programs in the UK, including admission requirements and program comparisons.",
        "confidence": 0.7,
        "category": "rankings"
      }
    ],
    "last_updated": "2025-09-11T18:00:57.191780"
  },
  "metadata": {
    "response_time": 30.1,
    "universities_analyzed": 3,
    "data_source": "LLM + Web Search",
    "course": "MBA",
    "your_brand": "Warwick Business School (YOU)",
    "competitors": [
      "University of Oxford",
      "London Business School"
    ],
    "timestamp": "2025-09-11T18:00:57.191870"
  }
};
